/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef} from 'react'
import {Link} from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useTranslation} from 'react-i18next'
import {getSalesAreaLetter, getSectorAll} from '../../../../api/modules/getdatalist'
import {createNew} from '../../../../api/modules/configuration/payment-due-date'
import {useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {Col, Row, Spinner} from 'react-bootstrap'
import {PageTitle} from '../../../../_metronic/layout/core'
import {MultiSelect} from 'react-multi-select-component'
import Checkbox from '../../access/Checkbox'
import i18next from 'i18next'

const FormAdd: React.FC = ({}) => {
  const {t} = useTranslation()

  const [fullSales, setFullSales] = useState<any[]>([])
  const [fullSektor, setFullSektor] = useState([])
  const fullTimeTypes = [
    {
      value: 'H',
      label: t('due-date-H')
    },
    {
      value: 'D',
      label: t('due-date-D')
    },
  ]

  const [sales, setSales] = useState([])
  const [sektor, setSektor] = useState([])
  const [timeType, setTimeType] = useState("H")
  const [time, setTime] = useState(0)
  const [status, setStatus] = useState(true)

  const navigate = useNavigate()

  const [btnLoading, setBtnLoading] = useState(false)

  useEffect(() => {
    const getSales = async () => {
      await getSalesAreaLetter().then((res) => {
        setFullSales(res.data.data)
      })
    }
    const getSector = async () => {
      const res = await getSectorAll()
      setFullSektor(res.data.data)
    }

    getSales()
    getSector()
  }, [])

  const handleClickStatus = (e: any) => {
    setStatus(e.target.checked)
  }

  const handleSubmit = async () => {
    setBtnLoading(true)

    await createNew({
      sector_ids: sektor.map((item: any) => item.value),
      sales_org_codes: sales.map((item: any) => item.value),
      time_type: timeType,
      time,
      is_active: status ? 1 : 0,
      lang: i18next.language,
      credentials: localStorage.getItem('credential'),
    })
      .then(() => {
        swal({
          title: `${t('configuration payment due date submited')}`,
          icon: 'success',
        }).then(() => navigate('/configuration/payment-due-date'))
      })
      .catch((error) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>• {t('Add Configuration payment due date')}</PageTitle>
      <div className={`card`}>
        <div className='card-body '>
          <Row className='mb-4'>
            <Col sm={6}>
              <Form.Label>{t('Sector')}</Form.Label>
              <MultiSelect
                options={fullSektor?.map((item: any) => {
                  return {label: t(item.name), value: item.id}
                })}
                value={sektor}
                onChange={setSektor}
                labelledBy='Select'
              />
            </Col>

            <Col sm={6}>
              <Form.Group className='mb-5' controlId='formBasicPassword'>
                <Form.Label>Sales Org</Form.Label>
                <MultiSelect
                  options={fullSales?.map((item: any) => {
                    return {label: t(item.name), value: item.code}
                  })}
                  value={sales}
                  onChange={setSales}
                  labelledBy='Select'
                />
              </Form.Group>
            </Col>

            <Col sm={6}>
              <Form.Group className='mb-5'>
                <Form.Label>{t('due-date')}</Form.Label>
                <Form.Control
                  id='quantum_2'
                  type='number'
                  min='0'
                  placeholder={t('due-date')}
                  value={time}
                  onChange={(e: any) => setTime(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col sm={6}>
              <Form.Group className='mb-5' controlId='formBasicPassword'>
                <Form.Label>{t('order-satuan')}</Form.Label>
                <Form.Select
                  aria-label='Default select example'
                  onChange={(e: any) => setTimeType(e.target.value)}
                >
                  {
                    fullTimeTypes.map((item: any) => {
                      return <option key={item.value} value={item.value}>{ item.label }</option>
                    } )
                  }
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className='mb-5'>
                <Checkbox
                  id='checkbox-status'
                  type='checkbox'
                  name='status'
                  handleClick={handleClickStatus}
                  isChecked={status}
                />
                <Form.Label className='ms-3'>{t('activate')}</Form.Label>
              </Form.Group>
            </Col>
          </Row>
        </div>

        <div className='d-flex justify-content-end p-8'>
          <Link to={'/configuration/signing'}>
            <Button className='btn btn-secondary me-2'>{t('berita-batal')}</Button>
          </Link>
          <Button className='btn btn-primary' onClick={() => handleSubmit()} disabled={btnLoading}>
            {btnLoading ? (
              <Spinner animation='border' variant='light' size='sm' />
            ) : (
              t('order-kirim')
            )}
          </Button>
        </div>
      </div>
    </>
  )
}

export {FormAdd}
